import {useState} from "react";
import {Button, DialogTrigger, Modal, Dialog} from "react-aria-components";
import ModalBody from "./ModalBody";
import ModalOverlay from "./ModalOverlay";
import CampusStaffDetails from "./CampusStaffDetails";
import {FCWithHTMLAttributes} from "../types/reactTypes";
import StaffMember from "../types/StaffMember";

const StaffBioModal: FCWithHTMLAttributes<{staffMember: StaffMember}> = ({
	children,
	staffMember,
}) => {
	const [isOpen, setOpen] = useState(false);
	return (
		<DialogTrigger>
			{/**
			 * we give the button the group class in order to support group
			 * styles on focus
			 */}
			<Button onPress={() => setOpen(true)} className="group">
				{children}
			</Button>
			<ModalOverlay isDismissable isOpen={isOpen} onOpenChange={setOpen}>
				<Modal className="max-h-full max-w-full overflow-auto p-4">
					<Dialog>
						<ModalBody
							onClose={() => setOpen(false)}
							className="w-[51.5rem] max-w-full"
						>
							<CampusStaffDetails {...staffMember} />
						</ModalBody>
					</Dialog>
				</Modal>
			</ModalOverlay>
		</DialogTrigger>
	);
};

export default StaffBioModal;
